import { render, staticRenderFns } from "./Digital-marketing.vue?vue&type=template&id=236bf629&scoped=true&"
import script from "./Digital-marketing.vue?vue&type=script&lang=js&"
export * from "./Digital-marketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bf629",
  null
  
)

export default component.exports